<template src="./ArrivalComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, watch, reactive} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import {useArrivalStore} from "@/stores/arrival.js";
import ModalArrivalChangeStatusComponent
  from "@/components/modals/modal-arrival-change-status/ModalArrivalChangeStatusComponent.vue";

export default {
  name: 'ArrivalComponent',
  components: {
    ModalArrivalChangeStatusComponent,
    ModalExportComponent,
    ModalProductImportComponent,
    LoadingComponent,
    ModalProductExportComponent,
    ModalDeliveryProductListComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      productName: {
        label: 'Tên sản phẩm',
        order: 1,
        width: '10%',
      },
      productCode: {
        label: 'Mã sản phẩm',
        order: 2,
        width: '10%',
      },
      warehouseName: {
        label: 'Tên kho hàng',
        order: 3,
        width: '10%',
      },
      warehouseCode: {
        label: 'Mã kho hàng',
        order: 4,
        width: '10%',
      },
      status: {
        label: 'Trạng thái',
        order: 5,
        width: '10%',
      },
      quantity: {
        label: 'Số lượng nhập',
        order: 6,
        width: '10%',
      },
      dateToWarehouse: {
        label: 'Ngày nhập hàng',
        order: 7,
        width: '10%',
      },
    })
    const labelButtonCreate = ref('Tạo nhập hàng')
    const labelButtonSearch = ref('Tìm kiếm')
    const urlOrigin = ref('/product/list/')
    const dataSearch = ref({
      product_name: {
        id: 'product_name',
        label: 'Tên sản phẩm',
        placeholder: 'Tên sản phẩm',
        value: '',
        required: false
      },
      product_code: {
        id: 'product_code',
        label: 'Mã sản phẩm',
        placeholder: 'Mã sản phẩm',
        value: '',
        required: false
      },
      warehouse_name: {
        id: 'warehouse_name',
        label: 'Tên kho hàng',
        placeholder: 'Tên kho hàng',
        value: '',
        required: false
      },
      warehouse_code: {
        id: 'warehouse_code',
        label: 'Mã kho hàng',
        placeholder: 'Mã kho hàng',
        value: '',
        required: false
      },
      warehouse_addr: {
        id: 'warehouse_addr',
        label: 'Địa chỉ kho hàng',
        placeholder: 'Địa chỉ kho hàng',
        value: '',
        required: false
      },
      date_to_arrival: {
        id: 'date_to_arrival',
        label: 'Ngày nhập hàng',
        placeholder: 'Ngày nhập hàng',
        value: '',
        required: false
      },
    })
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const eventClickShowModalChangeStatus = ref(false)
    const listArrivalsSelected = ref([])
    const isLoading = ref(false)
    const arrivalSelected = ref(null)
    const actionSelected = ref(null)
    const arrivalStatusChanged = ref(null)
    const messError = ref('')
    const location = ref('Sản phẩm')
    const table = ref('product')
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_ARRIVAL))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))
    const stateModal = reactive({
      modalArrivalChangeStatus: null,
    })
    const arrivalStore = useArrivalStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    onMounted(() => {
      getListArrivals(router.currentRoute.value.query.page ?? 1);
      stateModal.modalArrivalChangeStatus = new bootstrap.Modal('#modalArrivalChangeStatus', {})
    });

    const listArrivals = computed(() => {
      return arrivalStore.arrivals;
    });
    const paginate = computed(() => {
      return arrivalStore.paginate;
    });

    function emitPage(page) {
      getListArrivals(page);
    }
    function redirectToCreate() {
      router.push('/warehouse/arrival/create')
    }

    function getListArrivals(page, take = 10) {
      const params = {
        id: accountStore.account.company.id,
        product_name: dataSearch.value.product_name.value,
        product_code: dataSearch.value.product_code.value,
        warehouse_name: dataSearch.value.warehouse_name.value,
        warehouse_code: dataSearch.value.warehouse_code.value,
        warehouse_addr: dataSearch.value.warehouse_addr.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/arrival/arrival-list';
      arrivalStore.getListArrivalsWithLimit(url, params);
    }

    watch(() => arrivalStore.arrivals, (newListArrivals) => {
      newListArrivals.forEach((inventory) => {
        if(checkItems.value[inventory.id] === undefined) {
          checkItems.value[inventory.id] = false
        }
      })
    });
    function searchInventory() {
      getListArrivals(1);
    }

    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listArrivals.value.forEach((arrival) => {
          if(listItemSelected.value.indexOf(arrival.id) === -1) {
            listItemSelected.value.push(arrival.id)
          }
        })
      }
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listArrivals.value.forEach((product) => {
        if(checkItems.value[product.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(product.id) === -1 && parseInt(name) === parseInt(product.id)) {
          listItemSelected.value.push(product.id)
        }else if (!value && listItemSelected.value[product.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(product.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listArrivals.value.length) {
        checkAll.value = true
      }
    }
    function actionSelect(key) {
      let title = '';
      if(listItemSelected.value.length === 0) {
        title = 'Vui lòng chọn dữ liệu để thực hiện!';
      }
      if(listItemSelected.value.length > 1) {
        title = 'Vui lòng chỉ chọn 1 dữ liệu để thực hiện!';
      }
      if(title) {
        CommonService.showAlertPopup({
          title: title,
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
        return
      }

      listArrivals.value.forEach((arrival) => {
        if(listItemSelected.value.indexOf(arrival.id) !== -1) {
          arrivalSelected.value = arrival
        }
      })
      switch (parseInt(key)) {
        case AppConstant.ACTION_ARRIVAL_CHANGE_STATUS:
          actionSelected.value = AppConstant.ACTION_ARRIVAL_CHANGE_STATUS
          changeStatus();
          break;
        case AppConstant.ACTION_ARRIVAL_CANCEL:
          cancelArrival(key);
          break;
      }
    }

    function cancelArrival(key) {
      if([AppConstant.STATUS_ARRIVAL_FINISH_MOVE, AppConstant.STATUS_ARRIVAL_CANCEL].includes(arrivalSelected.value.status)) {
        CommonService.showAlertPopup({
          title: 'Chỉ thị nhập hàng không thể huỷ bỏ',
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        })
        return
      }
      CommonService.showAlertConfirmPopup({
        title: 'Bạn chắc chắn muốn huỷ bỏ chỉ thị nhập hàng này?',
        width: '800px'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const params = {
            id: accountStore.account.company.id,
            arrival_id: key,
          }
          const url = AppConstant.URL_API_LOCAL + 'api/arrival/cancel-arrival';
          const res = await arrivalStore.cancelArrival(url, params);
          await CommonService.showAlertPopup({
            title: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
            width: '800px'
          });
        }
      });
    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListArrivals(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListArrivals(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListArrivals(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }

    async function changeStatus() {
      showModalArrivalChangeStatus(true)
    }

    function showErrorMessage(mess) {
      messError.value = mess
    }

    function removeError() {
      messError.value = ''
    }

    function bindStatusChange(status) {
      arrivalStatusChanged.value = status
    }

    function eventShowModalChangeStatus(isShow) {
      if(isShow) {
        eventClickShowModalChangeStatus.value = true
        isLoading.value = false
      } else if(!isShow && !messError.value) {
        eventClickShowModalChangeStatus.value = false
        stateModal.modalArrivalChangeStatus.hide()
        isLoading.value = false
      }
      if(actionSelected.value === AppConstant.ACTION_ARRIVAL_CHANGE_STATUS && !messError.value && arrivalStatusChanged.value && arrivalStatusChanged.value !== AppConstant.STATUS_ARRIVAL_CREATE) {
        const arrivalSelectedIndex = listArrivals.value.findIndex((item) => item.id === arrivalSelected.value.id)
        listArrivals.value[arrivalSelectedIndex].status = arrivalStatusChanged.value
      }
    }

    function showModalArrivalChangeStatus(isShow) {
      if(isShow) {
        eventClickShowModalChangeStatus.value = true
        setTimeout(function () {
          eventClickShowModalChangeStatus.value = false
          isLoading.value = false
          stateModal.modalArrivalChangeStatus.show()
        }, 1000);
        return;
      }
      stateModal.modalArrivalChangeStatus.hide()
    }

    function showArrivalDetail(arrivalId) {
      router.push('/warehouse/arrival/detail/' + arrivalId)
    }

    return {
      listArrivals,
      dataHeaderTable,
      labelButtonSearch,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      listItemSelected,
      checkItems,
      selectAction,
      selectLimitPage,
      eventClickShowModalChangeStatus,
      listArrivalsSelected,
      isLoading,
      messError,
      location,
      table,
      labelButtonCreate,
      arrivalSelected,
      onChangeSelectAll,
      onChangeSelectItem,
      emitPage,
      redirectToCreate,
      searchInventory,
      onChange,
      actionSelect,
      actionLimitPage,
      showErrorMessage,
      bindStatusChange,
      removeError,
      eventShowModalChangeStatus,
      showArrivalDetail,
      CommonText,
      CommonService,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.arrival-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
